module.exports = __webpack_public_path__ + "img/logo_bccc.17b70450.png";